import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Music2, Podcast, Linkedin } from "lucide-react";
import Divider from "./Divider";
import client from "../lib/api";

export default function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    client.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const social = settings?.social || {};
  const socials = [
    { key: "instagram", label: "Instagram", Icon: Instagram },
    { key: "facebook", label: "Facebook", Icon: Facebook },
    { key: "linkedin", label: "LinkedIn", Icon: Linkedin },
    { key: "tiktok", label: "TikTok", Icon: Music2 },
    { key: "youtube", label: "YouTube", Icon: Youtube },
    { key: "spotify", label: "Spotify", Icon: Podcast },
  ];

  return (
    <footer data-testid="site-footer" className="bg-nero text-panna relative">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
        <div className="text-center mb-14">
          <p className="font-script text-3xl sm:text-4xl text-oro leading-relaxed max-w-3xl mx-auto">
            "Il vino è fatto dall'uomo, ognuno ha la sua storia personale, non è un prodotto standard.
            Stai bevendo storia, sacrificio e amore per la vite."
          </p>
          <p className="mt-4 text-sm uppercase tracking-[0.25em] text-panna/60">Stefano Cremonese</p>
        </div>
        <Divider light className="mb-14" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img src="/assets/logo-dark.png" alt="Dentro il Calice" className="h-20 w-auto mb-4" />
            <p className="text-sm text-panna/60 leading-relaxed">
              Storie di vino, persone e passione. Corsi, podcast e racconti per capire il vino senza snobismi.
            </p>
          </div>
          <div>
            <h3 className="font-serif text-lg text-oro mb-5">Navigazione</h3>
            <ul className="space-y-3 text-sm">
              {[["Home", "/"], ["Il Libro", "/il-libro"], ["Corsi", "/corsi"], ["Podcast", "/podcast"], ["Chi sono", "/chi-sono"], ["Blog", "/storie"], ["Contatti", "/contatti"]].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-panna/70 hover:text-oro transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-serif text-lg text-oro mb-5">Risorse</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/il-libro" className="text-panna/70 hover:text-oro transition-colors">Il libro "Dentro il Calice – Italia"</Link></li>
              <li><Link to="/#guida-gratuita" className="text-panna/70 hover:text-oro transition-colors">La guida gratuita</Link></li>
              <li><Link to="/podcast" className="text-panna/70 hover:text-oro transition-colors">Il podcast</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-serif text-lg text-oro mb-5">Contatti</h3>
            <ul className="space-y-3 text-sm text-panna/70">
              <li><a href="mailto:info@dentroilcalice.it" data-testid="footer-email" className="hover:text-oro transition-colors">info@dentroilcalice.it</a></li>
              <li><a href="tel:+393482618512" data-testid="footer-phone" className="hover:text-oro transition-colors">+39 348 2618 512</a></li>
              <li>
                <a href="https://wa.me/393482618512" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="hover:text-oro transition-colors">
                  WhatsApp
                </a>
              </li>
              <li className="text-panna/50">Piazza J.F. Kennedy 2<br />37060 Castel d'Azzano (VR)</li>
            </ul>
            <div className="flex gap-3 mt-5">
              {socials.map(({ key, label, Icon }) =>
                social[key] ? (
                  <a key={key} href={social[key]} target="_blank" rel="noopener noreferrer" aria-label={label}
                     data-testid={`social-${key}`}
                     className="h-9 w-9 rounded-full border border-oro/30 flex items-center justify-center text-oro hover:bg-bordeaux transition-colors">
                    <Icon size={16} />
                  </a>
                ) : (
                  <span key={key} aria-label={`${label} (in arrivo)`} data-testid={`social-${key}`}
                        className="h-9 w-9 rounded-full border border-panna/15 flex items-center justify-center text-panna/30 cursor-default" title={`${label} — in arrivo`}>
                    <Icon size={16} />
                  </span>
                )
              )}
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-panna/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-panna/40">
          <p>© 2026 Dentro il Calice è un marchio di Stefano Cremonese | P.IVA 04780750230</p>
          <div className="flex gap-5">
            <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-oro transition-colors">Privacy Policy</Link>
            <Link to="/cookie-policy" data-testid="footer-cookie" className="hover:text-oro transition-colors">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
